import React, { useEffect, useState } from 'react';
import { Col, Row, } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useDropzone } from 'react-dropzone';
import Flex from 'components/common/Flex';
import cloudUpload from 'assets/img/icons/cloud-upload.svg';


const DemandeDPSStep4 = ({
    setValue,
    watch,
}) => {
    const [files, setFiles] = useState([]);
    const { getRootProps, getInputProps } = useDropzone({
        maxFiles: 10,
        multiple: true,
        onDrop: acceptedFiles => {
            setFiles([
                ...files,
                ...acceptedFiles
            ]);
        }
    });

    const handleRemove = (path) => {
        setFiles(files.filter(file => file.path != path));
    };

    useEffect(()=>{
        if(files.length == 0 && watch("uploadedFiles") && Array.isArray(watch("uploadedFiles")))
        {
            setFiles(watch("uploadedFiles"));
        }
    },[])

    useEffect(()=>{
        if(files)
        {
            setValue("files", files);
        }
    },[files])

    return (<>
        <center>
            <h5 className='text-primary mb-2'>Documents</h5>
            <p>Partagez avec nous tout document utile (plan, itinéraire, plaquette informative, planning, ...)</p>
        </center>

        <Row>
            <Col md={files.length ? '6' : '12'}>
                <div {...getRootProps({ className: 'dropzone-area py-6' })}>
                    <input name="uploadedFiles" {...getInputProps()} />
                    <Flex justifyContent="center">
                        <img src={cloudUpload} alt="" width={25} className="me-2" />
                        <p className="fs-9 mb-0 text-700">Déposez vos fichiers ici</p>
                    </Flex>
                </div>
            </Col>
            <Col md={6}>
                <div className="mt-3">
                    {files.length > 0 && (
                    <>
                        <h6>Fichiers:</h6>
                        <ul>
                            {files.map(file => (
                                <li key={file.path}>
                                    {file.name} <Link className='text-danger' onClick={()=>{handleRemove(file.path)}}><FontAwesomeIcon icon='trash' /></Link>
                                </li>
                            ))}
                        </ul>
                    </>
                    )}
                </div>
            </Col>
        </Row>
    </>);
};


DemandeDPSStep4.propTypes = {};

export default DemandeDPSStep4;